import noPhoto from '../images/noPhoto.png';
import noPhotoFemale from '../images/noPhotoFemale.png';
import store from '@store/redux.store';
import { getCorrectFilePath } from './new/getCorrectFilePath';

const defaultAvatarKeysByRole = {
	children: 'defaultAvatarStudents',
	parent: 'defaultAvatarParents',
};

const getUserRole = (user) => {
	if (!user || typeof user !== 'object') return null;

	if (user.role) return user.role;
	if (Array.isArray(user.rolesName) && user.rolesName.length) return user.rolesName[0];
	if (Array.isArray(user.roles) && user.roles.length) {
		const role = user.roles[0];
		return typeof role === 'string' ? role : role?.item_name;
	}

	return null;
};

const parseDefaultAvatar = (value) => {
	if (!value) return null;
	if (value && typeof value === 'object') return value;

	try {
		return JSON.parse(value);
	} catch {
		return null;
	}
};

const getDefaultAvatar = (user) => {
	const role = getUserRole(user);
	if (!role) return null;

	const settingKey = defaultAvatarKeysByRole[role] ?? 'defaultAvatarColleagues';
	const avatar = parseDefaultAvatar(store.getState()?.settings?.custom?.[settingKey]);

	if (!avatar?.path) return null;
	if (String(avatar.path).startsWith('/static/')) return avatar.path;

	return getCorrectFilePath(avatar.path);
};

export const getAvatar = (user, src=false, srcPath='') => {

	if (src && srcPath) {
		return getCorrectFilePath(srcPath)
	}

	const avatarPath = typeof user === 'string' ? user : user?.avatar_path;
	const photo = user?.userProfile?.sex === 'Female' ? noPhotoFemale : noPhoto;

	if (avatarPath) {
		return getCorrectFilePath(avatarPath)
	}

	const defaultAvatar = getDefaultAvatar(user);
	if (defaultAvatar) {
		return defaultAvatar;
	}

	return photo;
};
